const authConfig = {
	oidc: {
		clientId: process.env.CLIENT_ID,
		issuer: process.env.ISSUER,
		redirectUri: `${window.location.origin}/login/callback`,
		scopes: ["openid", "profile", "email", "offline_access"],
	},
	resourceServer: {
		messagesUrl: "http://localhost:8000/api/messages",
	},
};

export { authConfig };
